import { GA_Push } from "./GoogleAnalytics";
import { mobile } from "./Agent";

var urlToShare = window.location.href;
var faceUrlToShare = `https://z.ynet.co.il//mshort/generics/Leads/osemdoingood/?utm_source=${mobile() ? "m.ynet.co.il":"ynet.co.il"}&utm_medium=social&utm_campaign=facebook&utm_term=Osem`
var textToShare = '  במסגרת פרויקט מתכון לחיים טובים המשותף לידיעות אחרונות, ynet ואסם-נסטלה, אנחנו מזמינים אתכם לכתוב ברכות משמחות ליום העצמאות - על כל ברכה שתשלח, אסם-נסטלה תשמח משפחה עם מארז מזון בשיתוף עם "לתת". כדי שלכולנו יהיו חגים שמחים.  ' + window.location.href;

const shareFacebook = () => {
  GA_Push("share_events", "Share From Site Head", "Facebook" , "Social");
  window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(faceUrlToShare), "_blank");
};

const shareTwitter = () => {
  GA_Push("share_events", "Share From Site Head", "Twitter" , "Social");
  window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(textToShare), "_blank");
};

const shareWhatsapp = () => {
  GA_Push("share_events", "Share From Site Head", "Whatsapp" , "Social");
  if (mobile()) {
    window.open("whatsapp://send?text=" + encodeURIComponent(textToShare), "_parent");
  } else {
    window.open("https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(textToShare), "_blank");
  }
};

const openNegishut = () => {
  window.document.getElementById("INDmenu-btn").click();
  GA_Push("Accessibility", "Open_Accessibility_Clicked");
};

export { shareFacebook, shareTwitter, shareWhatsapp, openNegishut };



// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js